import { JSX } from 'react';
import { SuggestiveDropdown } from '@ahc-digital/component-library';
import { C10SuggestiveDropdownListProps } from './C10SuggestiveDropdownList.types';
import { CreateSuggestiveDropDownListModel } from './C10SuggestiveDropdownList.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C10SuggestiveDropdownListProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <SuggestiveDropdown
      {...CreateSuggestiveDropDownListModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C10SuggestiveDropdownListProps>(Default);
